import { render, staticRenderFns } from "./MemberEvaluationTest.vue?vue&type=template&id=b120840e&scoped=true&"
import script from "./MemberEvaluationTest.vue?vue&type=script&lang=js&"
export * from "./MemberEvaluationTest.vue?vue&type=script&lang=js&"
import style0 from "./MemberEvaluationTest.vue?vue&type=style&index=0&id=b120840e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b120840e",
  null
  
)

export default component.exports